import styled from "styled-components";

export const BannerWrapper = styled.div`
  background-repeat: no-repeat;
  background-position: top left;
  background-size: cover;
  border-radius: 1.2rem;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.2rem;
  margin-right: 2rem;
`;

export const BannerImg = styled.img(
  props => `
    height: 16rem;
    width: 100%;
  `
)

